/* eslint-disable */
import createIcon from '../createIcon';

const IconSearchOutlined = createIcon({
  name: 'icon-search-outlined',
  content: '<path d="M449.234599 799.064095A350.466708 350.466708 0 1 1 799.701307 446.048538a350.466708 350.466708 0 0 1-350.466708 353.015557z m0-637.212197A286.745488 286.745488 0 1 0 735.980087 446.048538a286.108276 286.108276 0 0 0-286.745488-284.19664z"/><path d="M670.347231 714.059988l45.050902-45.050903 135.216428 135.152707-45.050902 45.050902z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconSearchOutlined;
